// extracted by mini-css-extract-plugin
export var block = "Content-module--block--8vGs-";